const { REACT_APP_API_URL = '' } = process.env

/**
 * The bare domain, matching the key `api/reducer.ts` mounts this slice under. The slice
 * itself is named `` `${NAMESPACE}Api` ``, so the action-type strings stay `invoiceApi/*`.
 */
export const NAMESPACE = 'invoice'

export const ENDPOINTS = {
  INVOICE_BASE: `${REACT_APP_API_URL}/invoices`,
  INVOICE_BASE_V2: `${REACT_APP_API_URL}/v2.0/invoices`,
  INVOICE_ENTITY: `${REACT_APP_API_URL}/invoices/:id/entity`,
  FETCH_INVOICE_TYPES: `${REACT_APP_API_URL}/invoices/invoice_types`,
  SEND_INVOICES: `${REACT_APP_API_URL}/invoices/send`,
  DELETE_INVOICES: `${REACT_APP_API_URL}/invoices/delete`,
  RESTORE_INVOICES: `${REACT_APP_API_URL}/invoices/restore`,
  NOTIFICATIONS: `${REACT_APP_API_URL}/invoices/notifications`,
  FETCH_DRAFT_INVOICES: `${REACT_APP_API_URL}/invoices/portfolio/:id/drafts`,
  BULK_INVOICES: `${REACT_APP_API_URL}/invoices/bulk_invoices`,
}

export const depositInvoiceTypes = ['ServiceDeposit', 'DamageDeposit', 'DepositTopUp', 'KeyDeposit']

/**
 * Invoice categories generated by the lease "Rent & fees" step (the `leaseRentAndFees` dialog):
 * rent, pro-rata rent, the three deposits and the lease/application/administration fees.
 * Templates in these categories are system-managed, so the invoices step renders them as
 * "auto-generated" (read-only "Invoice to", locked amount, no delete).
 */
export const rentAndFeesInvoiceTypes = [
  'RentInvoice',
  'ProRataRent',
  'ServiceDeposit',
  'DamageDeposit',
  'KeyDeposit',
  'LeaseFee',
  'ApplicationFee',
  'AdministrationFee',
]

/** Rent categories within `rentAndFeesInvoiceTypes` — the rent charge itself and its pro-rata first/last month. */
export const rentInvoiceTypes = ['RentInvoice', 'ProRataRent']

export const nonRecurringInvoiceTypes = [
  'BalanceBroughtForward',
  'CancellationFee',
  'CashDepositFee',
  'CreditCheckFee',
  'DebtCollectionFee',
  'IncomingInspection',
  'LatePaymentFee',
  'OutgoingInspection',
  'RenewalFee',
  'TenantRefund',
]

export const defaultAgencyInvoiceTypes = [
  'Commission',
  'ProcurementFee',
  'ApplicationFee',
  'LeaseFee',
  'RenewalFee',
  'IncomingInspection',
  'OutgoingInspection',
  'AdministrationFee',
  'CashDepositFee',
  'LatePaymentFee',
  'CreditCheckFee',
]

export const adhocOnlyInvoiceTypes = ['DepositHandover']

export const DEBOUNCE_TIME = 1000
